import { Box, List, Stack, Text } from "@chakra-ui/react";
import { t } from "i18next";
import { CraForecastAction } from "../../../../project/models/CraForecastScenario";
import {
  craAttributeFilterToString,
  isScoreFiltersEmpty,
  scoreFilterToString,
} from "../../../../map/models/MapFilters";
import { AttributeUtils } from "../../../../coding/utils/attribute-utils";
import { useStores } from "../../../../shared/stores/RootStore";

const i18prefix = "map:forecast.display.tooltip";

interface Props {
  change: CraForecastAction;
}
export const CraForecastActionTooltip: React.FC<Props> = ({ change }) => {
  const { osaWayStore } = useStores();
  const { osaWayFilters, treatmentFilters, scoreFilters, attributeFilters } =
    change.filters;
  const osaWayFiltersEmpty = !osaWayFilters.length;
  const scoreFiltersEmpty = isScoreFiltersEmpty(scoreFilters);
  const treatmentFiltersEmpty = !treatmentFilters.length;
  const attributeFiltersEmpty = !attributeFilters.length;
  const allEmpty =
    osaWayFiltersEmpty &&
    treatmentFiltersEmpty &&
    scoreFiltersEmpty &&
    attributeFiltersEmpty;

  return (
    <Stack p={2} minW="200px">
      <Text textAlign="center">{t(`${i18prefix}.title`)}</Text>

      {allEmpty && <Text fontSize="xs">{t(`${i18prefix}.empty`)}</Text>}

      {!osaWayFiltersEmpty && (
        <FilterList
          title={t(`${i18prefix}.route`)}
          items={osaWayFilters.map(
            (osaWayId) => osaWayStore.get(osaWayId)?.name ?? "*Not found*",
          )}
        />
      )}

      {!treatmentFiltersEmpty && (
        <FilterList
          title={t(`${i18prefix}.treatment`)}
          items={treatmentFilters.map((treatmentType, i) =>
            t(`map:treatments.${treatmentType}`),
          )}
        />
      )}

      {!scoreFiltersEmpty && (
        <FilterList
          title={t(`${i18prefix}.score`)}
          items={Object.entries(scoreFilters).map(
            ([crashType, filter], i) =>
              filter &&
              `${t(`sdk:score.key.${crashType}`)}: ${scoreFilterToString(
                filter,
              )}`,
          )}
        />
      )}

      {!attributeFiltersEmpty && (
        <FilterList
          title={t(`${i18prefix}.attribute`)}
          items={attributeFilters.map((attributeFilter) => {
            return `${AttributeUtils.getLabel(
              attributeFilter.attributeName,
            )}: ${craAttributeFilterToString(attributeFilter)}`;
          })}
        />
      )}
    </Stack>
  );
};

interface FilterListProps {
  title: string;
  items: string[];
}
const FilterList: React.FC<FilterListProps> = ({ title, items }) => {
  return (
    <Box>
      <Text fontWeight="semibold">{title}</Text>

      <List.Root fontSize="xs">
        {items.map((item, i) => (
          <List.Item key={i}>{item}</List.Item>
        ))}
      </List.Root>
    </Box>
  );
};
